import 'imagesloaded';
import 'owl.carousel';
import 'jssocials';

export default {
  isMobileAndroid() {
    return navigator.userAgent.match(/Android/i);
  },
  isMobileBlackBerry() {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  isMobileiOS() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  isMobileOpera() {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  isMobileWindows() {
    return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
  },
  isMobile: function () {
    return (this.isMobileAndroid() || this.isMobileBlackBerry() || this.isMobileiOS() || this.isMobileOpera() || this.isMobileWindows());
  },
  init() {
    // JavaScript to be fired on all pages
    let vm = this;
    jQuery(document).ready(function () {
      jQuery('body').imagesLoaded({background: true}, function () {
        vm.initAntiriciclaggio();
      });
    });
  },
  initAntiriciclaggio() {

    let vm = this;
    if (vm.isMobile()) {
      jQuery('body').addClass('mobile');
    }

    jQuery('.share-content').jsSocials({
      showLabel: false,
      shareIn: 'popup',
      showCount: false,
      shares: [
        {
          share: 'facebook',
        },
        {
          share: 'linkedin',
        },
        {
          share: 'twitter',
        },
      ],
    });

    jQuery(this).on('click', 'a.forheader[href^="#"]', function (event) {
      event.preventDefault();
      jQuery('html, body').animate({
        scrollTop: jQuery(jQuery.attr(this, 'href')).offset().top - 30,
      }, 500);
    });

    jQuery('.owl-carousel.slider').owlCarousel({
      items: 1,
      loop: true,
      margin: 0,
      nav: false,
      dot: true,
      autoplay: false,
    });

    jQuery('.owl-carousel.formazione-carousel').owlCarousel({
      margin: 30,
      nav: false,
      autoplay: false,
      responsive: {
        0: {
          loop: true,
          dot: true,
          items: 1,
        },
        768: {
          items: 2,
          loop: true,
        },
        1024: {
          dot: false,
          items: 3,
          loop: false,
        },
      },
    });

    jQuery('#hamburger').click(function () {
      jQuery(this).toggleClass('open');
      jQuery('header nav').slideToggle();
    });
/*
    jQuery('#search-button').click(function () {
      jQuery('.search-input-wrap').fadeIn();
    });

    jQuery('.close-mobile').click(function () {
      jQuery('.search-input-wrap').fadeOut();
    });
*/
    jQuery('.backtotop').click(function () {
      jQuery('html, body').animate({scrollTop: 0}, 200);
    });

    jQuery('main .aside-sommario > h3').click(function () {
      jQuery('main .aside-sommario .list').slideToggle();
      jQuery(this).toggleClass('open');
    });

    jQuery('#custom_login').submit(function (event) {
      if (jQuery('#user_login').val() === '' || jQuery('#user_pass').val() === '') {
        jQuery('.form-custom-login-error').text('Inserisci username e password');
        event.preventDefault();
        return false;
      }
    })

    $('.aside-newsletter form').on('submit', function () {
      console.log('partita');
      window._iub.cons_instructions.push(['submit', {
        writeOnLocalStorage: false, // default: false
        form: {
          selector: jQuery('#form-custom-newsletter'),
          map: {
            subject: {
              first_name: 'txtname',
              last_name: 'txtsurname',
              email: 'txtEmail',
            },
            preferences: {
              privacy: 'ckbox',
              },
            },
        },
        consent: {
          legal_notices: [
            { identifier: 'privacy_policy' },                   
            { identifier: 'cookie_policy'  },
            { identifier: 'term' },
            ],
          },
        },
        {
          success: function(response) {
          console.log(response);
          }, 
          error: function(response) {
          console.log(response);
          },
        },
      ]);
    });

    jQuery('#close-modal-search').click(function () {
      jQuery('.modale-search').fadeOut();
  });

  jQuery('.ricerca-avanzata-sidebar').click(function () {
      jQuery('.modale-search').fadeIn().css('display','flex');
  });

  var objimg = jQuery('.item-banner');
  var numitem=objimg.length;
  var numcount=0;
  var theInterval;
  if (jQuery('.slideshow-banner')[0]){
      startSlide();
  }

  function startSlide() {
      theInterval = setInterval(timerSlides, 2000);
  }
  
  console.log(theInterval);

  function stopSlide() {
      clearInterval(theInterval);
  }

  jQuery('.next-banner').click(function(){
      numcount++;
      if (numcount > numitem) {
          numcount = 1
      }
      jQuery(objimg).removeClass( 'active' );
      jQuery(objimg[numcount-1]).addClass( 'active' );
      stopSlide() ;
  });

  jQuery('.prev-banner').click(function(){
      numcount--;
      if (numcount < 0) {
          numcount = numitem-1;
      }
      jQuery(objimg).removeClass( 'active' );
      jQuery(objimg[numcount]).addClass( 'active' );
      stopSlide() ;
  });


  function timerSlides() {
      numcount++;
      if (numcount > numitem) {
          numcount = 1
      }
          jQuery(objimg).removeClass( 'active' );
          jQuery(objimg[numcount-1]).addClass( 'active' );
      } 


      jQuery('.eye1').click(function(){
        jQuery(this).toggleClass('nothiddenpw');
        jQuery('.inputpw1').attr('type', function(index, attr){
            return attr == 'password' ? 'text' : 'password';
        });
      });
      jQuery('.eye2').click(function(){
        jQuery(this).toggleClass('nothiddenpw');
        jQuery('.inputpw2').attr('type', function(index, attr){
            return attr == 'password' ? 'text' : 'password';
        });
      });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js